import axios from "axios";
import {
    EVERSIGN_DUCOMENTS_URL,
    LEADS_URL,
    SOLUTIONS_URL,
} from "../../API/Api";

const GetSolutionsCount = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        baseURL: `${SOLUTIONS_URL}`,
        headers,
        params: { count: 1, ...data },
    });
    return response.data;
};

const GetLeadsCard = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        baseURL: `${LEADS_URL}`,
        headers,
        params: { count: 1, ...data },
    });
    return response.data;
};

const GetEverSignDocumentSigned = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    let response = await axios({
        method: "GET",
        baseURL: `${EVERSIGN_DUCOMENTS_URL}/card/signed`,
        headers,
        params: { ...data },
    });
    return response.data;
};

const GetEverSignDocumentUnSigned = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    let response = await axios({
        method: "GET",
        baseURL: `${EVERSIGN_DUCOMENTS_URL}/card/unsigned`,
        headers,
        params: { ...data },
    });
    return response.data;
};

const CardService = {
    GetSolutionsCount,
    GetLeadsCard,
    GetEverSignDocumentSigned,
    GetEverSignDocumentUnSigned,
};

export default CardService;
